import React, { Component } from 'react'
import { connect } from 'react-redux'
import { default as Dialog } from 'material-ui/Dialog'
import {
  closeCustomizeBuildingForm,
  updateField,
  updateBuilding,
  fetchBuildings,
  cancelUnlockImage,
  changeUnlockImage,
  cancelLockImage,
  changeLockImage,
  updateCustomizeBuilding,
  cancelSelectedHomeImage,
  changeSelectedHomeImage,
  cancelUnselectedHomeImage,
  changeUnselectedHomeImage,
  cancelCheckInImage,
  changeCheckInImage,
  cancelSelectedProfileImage,
  changeSelectedProfileImage,
  cancelUnselectedProfileImage,
  changeUnselectedProfileImage,
  updateDoCustomizeField,
  updateBookCustomizeField,
  updateAssemblyCustomizeField,
  updateFilterCustomizeField
} from '../../actions/buildings'
import { default as FlatButton } from 'material-ui/FlatButton/FlatButton'
import { default as TextField } from 'material-ui/TextField/TextField'
import { Tab, Tabs } from 'material-ui/Tabs'
// import { default as Cropper } from 'react-cropper'
import Cropper from 'react-cropper'
import './Customize Buildings.css'

const customContentStyle = {
  width: '70%',
  maxWidth: 'none'
}

const leftPanelStyle = {
  float: 'left',
  width: '50%'
}

const rightPanelStyle = {
  float: 'right',
  padding: 10,
  width: '45%'
}

const styles = {
  uploadButton: {
    verticalAlign: 'middle'
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  tab: {
    minHeight: 400,
    fullWidth: 1000
  }
}
export class CustomizeBuildings extends Component {
  static defaultProps = {
    showCustomizeForm: false
  }
  componentDidMount() {
    fetchBuildings()
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeCustomizeBuildingForm())
  }

  updateField(event) {
    if (
      (event.target.value.length >= 0 && RegExp(/[a-zA-Z0-9 #]+/).test(event.target.value.slice(-1))) ||
      event.target.value == ''
    ) {
      const { dispatch } = this.props
      dispatch(updateField(event.target.name, event.target.value))
    } else {
      event.target.value = ''
    }
  }

  updateDoCustomizeField(event) {
    if (
      (event.target.value.length >= 0 && RegExp(/[a-zA-Z0-9 #]+/).test(event.target.value.slice(-1))) ||
      event.target.value == ''
    ) {
      const { dispatch } = this.props
      dispatch(updateDoCustomizeField(event.target.name, event.target.value))
    } else {
      event.target.value = ''
    }
  }

  updateBookCustomizeField(event) {
    if (
      (event.target.value.length >= 0 && RegExp(/[a-zA-Z0-9 #]+/).test(event.target.value.slice(-1))) ||
      event.target.value == ''
    ) {
      const { dispatch } = this.props
      dispatch(updateBookCustomizeField(event.target.name, event.target.value))
    } else {
      event.target.value = ''
    }
  }

  updateAssemblyCustomizeField(event) {
    const { dispatch } = this.props
    dispatch(updateAssemblyCustomizeField(event.target.name, event.target.value))
  }

  updateFilterCustomizeField(event) {
    const { dispatch } = this.props
    dispatch(updateFilterCustomizeField(event.target.name, event.target.value))
  }

  updateBuilding() {
    const { dispatch } = this.props
    dispatch(updateBuilding(this.props.building))
  }
  updateCustomizeBuilding() {
    const { dispatch } = this.props
    dispatch(updateCustomizeBuilding(this.props.building))
  }

  cancelUnlockImage(event) {
    const { dispatch } = this.props
    dispatch(cancelUnlockImage())
  }

  cancelLockImage(event) {
    const { dispatch } = this.props
    dispatch(cancelLockImage())
  }

  cancelSelectedHomeImage(event) {
    const { dispatch } = this.props
    dispatch(cancelSelectedHomeImage())
  }

  cancelUnselectedHomeImage(event) {
    const { dispatch } = this.props
    dispatch(cancelUnselectedHomeImage())
  }

  cancelCheckInImage(event) {
    const { dispatch } = this.props
    dispatch(cancelCheckInImage())
  }

  cancelSelectedProfileImage(event) {
    const { dispatch } = this.props
    dispatch(cancelSelectedProfileImage())
  }

  cancelUnselectedProfileImage(event) {
    const { dispatch } = this.props
    dispatch(cancelUnselectedProfileImage())
  }

  onUnlockImageChange(event) {
    const { dispatch } = this.props

    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      dispatch(changeUnlockImage(reader.result))
    }
    reader.readAsDataURL(files[0])
  }

  onLockImageChange(event) {
    const { dispatch } = this.props

    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      dispatch(changeLockImage(reader.result))
    }
    reader.readAsDataURL(files[0])
  }

  onSelectedHomeImageChange(event) {
    const { dispatch } = this.props

    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      dispatch(changeSelectedHomeImage(reader.result))
    }
    reader.readAsDataURL(files[0])
  }

  onUnselectedHomeImageChange(event) {
    const { dispatch } = this.props

    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      dispatch(changeUnselectedHomeImage(reader.result))
    }
    reader.readAsDataURL(files[0])
  }

  onCheckInImageChange(event) {
    const { dispatch } = this.props

    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      dispatch(changeCheckInImage(reader.result))
    }
    reader.readAsDataURL(files[0])
  }

  onSelectedProfileImageChange(event) {
    const { dispatch } = this.props

    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      dispatch(changeSelectedProfileImage(reader.result))
    }
    reader.readAsDataURL(files[0])
  }

  onUnselectedProfileImageChange(event) {
    const { dispatch } = this.props

    event.preventDefault()
    let files
    if (event.dataTransfer) {
      files = event.dataTransfer.files
    } else if (event.target) {
      files = event.target.files
    }
    const reader = new FileReader()
    reader.onload = () => {
      dispatch(changeUnselectedProfileImage(reader.result))
    }
    reader.readAsDataURL(files[0])
  }

  cropUnlockImage() {
    const { dispatch } = this.props

    if (typeof this.cropperUnlock.getCroppedCanvas() === 'undefined') {
      return
    }

    dispatch(changeUnlockImage(this.cropper.getCroppedCanvas() && this.cropper.getCroppedCanvas().toDataURL()))
  }

  cropLockImage() {
    const { dispatch } = this.props

    if (typeof this.cropperLock.getCroppedCanvas() === 'undefined') {
      return
    }

    dispatch(changeLockImage(this.cropperLock.getCroppedCanvas().toDataURL()))
  }

  cropSelectedHomeImage() {
    const { dispatch } = this.props

    if (typeof this.cropperSelectedHome.getCroppedCanvas() === 'undefined') {
      return
    }

    dispatch(changeSelectedHomeImage(this.cropperSelectedHome.getCroppedCanvas().toDataURL()))
  }

  cropUnselectedHomeImage() {
    const { dispatch } = this.props

    if (typeof this.cropperUnselectedHome.getCroppedCanvas() === 'undefined') {
      return
    }

    dispatch(changeUnselectedHomeImage(this.cropperUnselectedHome.getCroppedCanvas().toDataURL()))
  }

  cropCheckInImage() {
    const { dispatch } = this.props

    if (typeof this.cropperCheckIn.getCroppedCanvas() === 'undefined') {
      return
    }

    dispatch(changeCheckInImage(this.cropperCheckIn.getCroppedCanvas().toDataURL()))
  }

  cropSelectedProfileImage() {
    const { dispatch } = this.props

    if (typeof this.cropperSelectedProfile.getCroppedCanvas() === 'undefined') {
      return
    }

    dispatch(changeSelectedProfileImage(this.cropperSelectedProfile.getCroppedCanvas().toDataURL()))
  }

  cropUnselectedProfileImage() {
    const { dispatch } = this.props

    if (typeof this.cropperUnselectedProfile.getCroppedCanvas() === 'undefined') {
      return
    }

    dispatch(changeUnselectedProfileImage(this.cropperUnselectedProfile.getCroppedCanvas().toDataURL()))
  }

  forceUpdateComponent() {
    this.forceUpdate()
  }

  render() {
    if (this.props.building) {
      const actions = [
        <div>
          <FlatButton label='Cancel' primary={true} onClick={this.closeDialog.bind(this)} />

          <FlatButton label={'Customize Building'} primary={true} onClick={this.updateCustomizeBuilding.bind(this)} />
        </div>
      ]
      return (
        <Dialog
          id={'CustomizeBuildingPopup'}
          actions={actions}
          title='Customize Building'
          modal={true}
          autoScrollBodyContent={true}
          contentStyle={customContentStyle}
          open={this.props.showCustomizeForm}>
          <Tabs>
            <Tab label='Navigation Bar'>
              <div style={leftPanelStyle}>
                <TextField
                  style={{ width: '350px' }}
                  name='navColor'
                  hintText='Navigation Bar HexColor'
                  floatingLabelText='Navigation Bar HexColor'
                  maxlength='7'
                  value={
                    this.props.building.navColor
                      ? this.props.building.navColor.indexOf('#') > -1
                        ? this.props.building.navColor
                        : '#' + this.props.building.navColor
                      : null
                  }
                  onChange={this.updateField.bind(this)}
                />
                <div
                  className='square'
                  style={{
                    backgroundColor: this.props.building.navColor
                      ? this.props.building.navColor.indexOf('#') > -1
                        ? this.props.building.navColor
                        : '#' + this.props.building.navColor
                      : '#fff000'
                  }}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='statusBarBackgroundColor'
                  hintText='Status Bar HexColor'
                  floatingLabelText='Status Bar HexColor'
                  maxlength='7'
                  value={
                    this.props.building.statusBarBackgroundColor
                      ? this.props.building.statusBarBackgroundColor.indexOf('#') > -1
                        ? this.props.building.statusBarBackgroundColor
                        : '#' + this.props.building.statusBarBackgroundColor
                      : null
                  }
                  onChange={this.updateField.bind(this)}
                />
                <div
                  className='square'
                  style={{
                    backgroundColor: this.props.building.statusBarBackgroundColor
                      ? this.props.building.statusBarBackgroundColor.indexOf('#') > -1
                        ? this.props.building.statusBarBackgroundColor
                        : '#' + this.props.building.statusBarBackgroundColor
                      : '#fff000'
                  }}
                />
                <br />
              </div>
              <div style={rightPanelStyle}>
                {/* update unlockImage */}
                <Cropper
                  style={{ height: 40, width: '25%', scrollable: 'true' }}
                  aspectRatio={1 / 1}
                  guides={false}
                  src={
                    this.props.building.newUnlockImage
                      ? this.props.building.newUnlockImage
                      : this.props.building.unlockImage
                  }
                  ref={cropper => {
                    this.cropperUnlock = cropper
                  }}
                />
                <br />
                <br />
                <br />
                {this.props.building.newUnlockImage ? (
                  <FlatButton
                    fullWidth={false}
                    label='Cancel'
                    labelPosition='before'
                    style={styles.uploadButton}
                    containerElement='label'
                    onClick={this.cancelUnlockImage.bind(this)}
                  />
                ) : null}
                <FlatButton
                  fullWidth={false}
                  label='Crop'
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'
                  onClick={this.cropUnlockImage.bind(this)}
                />
                <FlatButton
                  fullWidth={false}
                  label={this.props.building.unlockImage ? 'Change Unlock Image' : 'Choose an Unlock Image'}
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'>
                  <input type='file' style={styles.uploadInput} onChange={this.onUnlockImageChange.bind(this)} />
                </FlatButton>

                {/* update lockImage */}
                <Cropper
                  style={{ height: 40, width: '25%', scrollable: 'true' }}
                  aspectRatio={1 / 1}
                  guides={false}
                  src={
                    this.props.building.newLockImage ? this.props.building.newLockImage : this.props.building.lockImage
                  }
                  ref={cropper => {
                    this.cropperLock = cropper
                  }}
                />
                <br />
                <br />
                <br />
                {this.props.building.newLockImage ? (
                  <FlatButton
                    fullWidth={false}
                    label='Cancel'
                    labelPosition='before'
                    style={styles.uploadButton}
                    containerElement='label'
                    onClick={this.cancelLockImage.bind(this)}
                  />
                ) : null}
                <FlatButton
                  fullWidth={false}
                  label='Crop'
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'
                  onClick={this.cropLockImage.bind(this)}
                />
                <FlatButton
                  fullWidth={false}
                  label={this.props.building.lockImage ? 'Change Lock Image' : 'Choose a Lock Image'}
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'>
                  <input type='file' style={styles.uploadInput} onChange={this.onLockImageChange.bind(this)} />
                </FlatButton>

                {/* update  selected homeImage */}
                <Cropper
                  style={{ height: 40, width: '25%', scrollable: 'true' }}
                  aspectRatio={1 / 1}
                  guides={false}
                  src={
                    this.props.building.homeImage && this.props.building.homeImage.newSelectedHomeImage
                      ? this.props.building.homeImage.newSelectedHomeImage
                      : this.props.building.homeImage && this.props.building.homeImage.selected
                      ? this.props.building.homeImage.selected
                      : null
                  }
                  ref={cropper => {
                    this.cropperSelectedHome = cropper
                  }}
                />
                <br />
                <br />
                <br />
                {this.props.building.homeImage && this.props.building.homeImage.newSelectedHomeImage ? (
                  <FlatButton
                    fullWidth={false}
                    label='Cancel'
                    labelPosition='before'
                    style={styles.uploadButton}
                    containerElement='label'
                    onClick={this.cancelSelectedHomeImage.bind(this)}
                  />
                ) : null}
                <FlatButton
                  fullWidth={false}
                  label='Crop'
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'
                  onClick={this.cropSelectedHomeImage.bind(this)}
                />
                <FlatButton
                  fullWidth={false}
                  label={
                    this.props.building.homeImage && this.props.building.homeImage.selected
                      ? 'Change Selected Home Image'
                      : 'Choose a Selected Home Image'
                  }
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'>
                  <input type='file' style={styles.uploadInput} onChange={this.onSelectedHomeImageChange.bind(this)} />
                </FlatButton>

                {/* update  unselected homeImage */}
                <Cropper
                  style={{ height: 40, width: '25%', scrollable: 'true' }}
                  aspectRatio={1 / 1}
                  guides={false}
                  src={
                    this.props.building.homeImage && this.props.building.homeImage.newUnselectedHomeImage
                      ? this.props.building.homeImage.newUnselectedHomeImage
                      : this.props.building.homeImage && this.props.building.homeImage.unselected
                      ? this.props.building.homeImage.unselected
                      : null
                  }
                  ref={cropper => {
                    this.cropperUnselectedHome = cropper
                  }}
                />
                <br />
                <br />
                <br />
                {this.props.building.homeImage && this.props.building.homeImage.newUnselectedHomeImage ? (
                  <FlatButton
                    fullWidth={false}
                    label='Cancel'
                    labelPosition='before'
                    style={styles.uploadButton}
                    containerElement='label'
                    onClick={this.cancelUnselectedHomeImage.bind(this)}
                  />
                ) : null}
                <FlatButton
                  fullWidth={false}
                  label='Crop'
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'
                  onClick={this.cropUnselectedHomeImage.bind(this)}
                />
                <FlatButton
                  fullWidth={false}
                  label={
                    this.props.building.homeImage && this.props.building.homeImage.unselected
                      ? 'Change Unselected Home Image'
                      : 'Choose a Unselected Home Image'
                  }
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'>
                  <input
                    type='file'
                    style={styles.uploadInput}
                    onChange={this.onUnselectedHomeImageChange.bind(this)}
                  />
                </FlatButton>

                {/* update selectedProfileImage */}
                <Cropper
                  style={{ height: 40, width: '25%', scrollable: 'true' }}
                  aspectRatio={1 / 1}
                  src={
                    this.props.building.profileImage && this.props.building.profileImage.newSelectedProfileImage
                      ? this.props.building.profileImage.newSelectedProfileImage
                      : this.props.building.profileImage && this.props.building.profileImage.selected
                      ? this.props.building.profileImage.selected
                      : null
                  }
                  ref={cropper => {
                    this.cropperSelectedProfile = cropper
                  }}
                />
                <br />
                <br />
                <br />
                {this.props.building.profileImage && this.props.building.profileImage.newSelectedProfileImage ? (
                  <FlatButton
                    fullWidth={false}
                    label='Cancel'
                    labelPosition='before'
                    style={styles.uploadButton}
                    containerElement='label'
                    onClick={this.cancelSelectedProfileImage.bind(this)}
                  />
                ) : null}
                <FlatButton
                  fullWidth={false}
                  label='Crop'
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'
                  onClick={this.cropSelectedProfileImage.bind(this)}
                />
                <FlatButton
                  fullWidth={false}
                  label={
                    this.props.building.profileImage && this.props.building.profileImage.selected
                      ? 'Change Selected Profile Image'
                      : 'Choose a  Selected Profile Image'
                  }
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'>
                  <input
                    type='file'
                    style={styles.uploadInput}
                    onChange={this.onSelectedProfileImageChange.bind(this)}
                  />
                </FlatButton>

                {/* update unselectedProfileImage */}
                <Cropper
                  style={{ height: 40, width: '25%', scrollable: 'true' }}
                  aspectRatio={1 / 1}
                  src={
                    this.props.building.profileImage && this.props.building.profileImage.newUnselectedProfileImage
                      ? this.props.building.profileImage.newUnselectedProfileImage
                      : this.props.building.profileImage && this.props.building.profileImage.unselected
                      ? this.props.building.profileImage.unselected
                      : null
                  }
                  ref={cropper => {
                    this.cropperUnselectedProfile = cropper
                  }}
                />
                <br />
                <br />
                <br />
                {this.props.building.profileImage && this.props.building.profileImage.newUnselectedProfileImage ? (
                  <FlatButton
                    fullWidth={false}
                    label='Cancel'
                    labelPosition='before'
                    style={styles.uploadButton}
                    containerElement='label'
                    onClick={this.cancelUnselectedProfileImage.bind(this)}
                  />
                ) : null}
                <FlatButton
                  fullWidth={false}
                  label='Crop'
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'
                  onClick={this.cropUnselectedProfileImage.bind(this)}
                />
                <FlatButton
                  fullWidth={false}
                  label={
                    this.props.building.profileImage && this.props.building.profileImage.unselected
                      ? 'Change Unselected Profile Image'
                      : 'Choose a Unselected Profile Image'
                  }
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'>
                  <input
                    type='file'
                    style={styles.uploadInput}
                    onChange={this.onUnselectedProfileImageChange.bind(this)}
                  />
                </FlatButton>

                {/* update checkInImage */}
                <Cropper
                  style={{ height: 40, width: '25%', scrollable: 'true' }}
                  aspectRatio={1 / 1}
                  guides={false}
                  src={
                    this.props.building.newCheckInImage
                      ? this.props.building.newCheckInImage
                      : this.props.building.checkInImage
                  }
                  ref={cropper => {
                    this.cropperCheckIn = cropper
                  }}
                />
                <br />
                <br />
                <br />
                {this.props.building.newCheckInImage ? (
                  <FlatButton
                    fullWidth={false}
                    label='Cancel'
                    labelPosition='before'
                    style={styles.uploadButton}
                    containerElement='label'
                    onClick={this.cancelCheckInImage.bind(this)}
                  />
                ) : null}
                <FlatButton
                  fullWidth={false}
                  label='Crop'
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'
                  onClick={this.cropCheckInImage.bind(this)}
                />
                <FlatButton
                  fullWidth={false}
                  label={this.props.building.checkInImage ? 'Change CheckIn Image' : 'Choose a CheckIn Image'}
                  labelPosition='before'
                  style={styles.uploadButton}
                  containerElement='label'>
                  <input type='file' style={styles.uploadInput} onChange={this.onCheckInImageChange.bind(this)} />
                </FlatButton>
              </div>
            </Tab>

            {/* DO Customization */}
            <Tab label='DO'>
              <div style={leftPanelStyle}>
                {/* <FlatButton onClick={this.forceUpdateComponent.bind(this)}>foo</FlatButton> */}
                <h3>List Event</h3>
                <TextField
                  style={{ width: '350px' }}
                  name='listBackgroundColor'
                  hintText='Background HexColor'
                  floatingLabelText='Background HexColor'
                  maxlength='7'
                  value={
                    this.props.building.doCustomize
                      ? this.props.building.doCustomize.listBackgroundColor
                        ? this.props.building.doCustomize.listBackgroundColor.indexOf('#') > -1
                          ? this.props.building.doCustomize.listBackgroundColor
                          : '#' + this.props.building.doCustomize.listBackgroundColor
                        : null
                      : null
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <div
                  className='square'
                  style={{
                    backgroundColor: this.props.building.doCustomize ? (
                      this.props.building.doCustomize.listBackgroundColor ? (
                        this.props.building.doCustomize.listBackgroundColor.indexOf('#') > -1 ? (
                          this.props.building.doCustomize.listBackgroundColor
                        ) : (
                          '#' + this.props.building.doCustomize.listBackgroundColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    )
                  }}
                />
                <br />
                <br />
                <div
                  className='text'
                  style={{
                    color: this.props.building.doCustomize ? (
                      this.props.building.doCustomize.listEventTitleColor ? (
                        this.props.building.doCustomize.listEventTitleColor.indexOf('#') > -1 ? (
                          this.props.building.doCustomize.listEventTitleColor
                        ) : (
                          '#' + this.props.building.doCustomize.listEventTitleColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    ),
                    fontStyle: this.props.building.doCustomize
                      ? this.props.building.doCustomize.listEventTitleStyle
                      : 'normal',
                    fontSize: this.props.building.doCustomize
                      ? this.props.building.doCustomize.listEventTitleSize + 'px'
                      : '14px',
                    textAlign: 'center'
                  }}>
                  Title Text
                </div>
                <br />
                <br />

                <TextField
                  style={{ width: '350px' }}
                  name='listEventTitleColor'
                  hintText='HexColor'
                  floatingLabelText4='HexColor'
                  maxlength='7'
                  value={
                    this.props.building.doCustomize
                      ? this.props.building.doCustomize.listEventTitleColor
                        ? this.props.building.doCustomize.listEventTitleColor.indexOf('#') > -1
                          ? this.props.building.doCustomize.listEventTitleColor
                          : '#' + this.props.building.doCustomize.listEventTitleColor
                        : null
                      : null
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='listEventTitleStyle'
                  hintText='Style'
                  floatingLabelText2='Style'
                  value={
                    this.props.building.doCustomize ? this.props.building.doCustomize.listEventTitleStyle : 'normal'
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='listEventTitleSize'
                  hintText='Size'
                  floatingLabelText1='Size'
                  value={this.props.building.doCustomize ? this.props.building.doCustomize.listEventTitleSize : '14px'}
                  onChange={this.updateDoCustomizeField.bind(this)}
                />

                <br />
                <br />
                <div
                  className='text'
                  style={{
                    color: this.props.building.doCustomize ? (
                      this.props.building.doCustomize.listEventDateColor ? (
                        this.props.building.doCustomize.listEventDateColor.indexOf('#') > -1 ? (
                          this.props.building.doCustomize.listEventDateColor
                        ) : (
                          '#' + this.props.building.doCustomize.listEventDateColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    ),
                    fontStyle: this.props.building.doCustomize
                      ? this.props.building.doCustomize.listEventDateStyle
                      : 'normal',
                    fontSize: this.props.building.doCustomize
                      ? this.props.building.doCustomize.listEventDateSize + 'px'
                      : '14px',
                    textAlign: 'center'
                  }}>
                  Date Text
                </div>
                <br />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='listEventDateColor'
                  hintText='HexColor'
                  floatingLabelText4='HexColor'
                  maxlength='7'
                  value={
                    this.props.building.doCustomize
                      ? this.props.building.doCustomize.listEventDateColor
                        ? this.props.building.doCustomize.listEventDateColor.indexOf('#') > -1
                          ? this.props.building.doCustomize.listEventDateColor
                          : '#' + this.props.building.doCustomize.listEventDateColor
                        : null
                      : null
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />

                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='listEventDateStyle'
                  hintText='Style'
                  floatingLabelText2='Style'
                  value={
                    this.props.building.doCustomize ? this.props.building.doCustomize.listEventDateStyle : 'normal'
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='listEventDateSize'
                  hintText='Size'
                  floatingLabelText1='Size'
                  value={this.props.building.doCustomize ? this.props.building.doCustomize.listEventDateSize : '14px'}
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
              </div>
              <div style={rightPanelStyle}>
                <h3>Details Event</h3>
                <TextField
                  style={{ width: '350px' }}
                  name='detailsBackgroundColor'
                  hintText='Background HexColor'
                  floatingLabelText='Background HexColor'
                  maxlength='7'
                  value={
                    this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsBackgroundColor
                        ? this.props.building.doCustomize.detailsBackgroundColor.indexOf('#') > -1
                          ? this.props.building.doCustomize.detailsBackgroundColor
                          : '#' + this.props.building.doCustomize.detailsBackgroundColor
                        : null
                      : null
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <div
                  className='square'
                  style={{
                    backgroundColor: this.props.building.doCustomize ? (
                      this.props.building.doCustomize.detailsBackgroundColor ? (
                        this.props.building.doCustomize.detailsBackgroundColor.indexOf('#') > -1 ? (
                          this.props.building.doCustomize.detailsBackgroundColor
                        ) : (
                          '#' + this.props.building.doCustomize.detailsBackgroundColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    )
                  }}
                />
                <br />
                <br />
                <div
                  className='text'
                  style={{
                    color: this.props.building.doCustomize ? (
                      this.props.building.doCustomize.detailsEventTitleColor ? (
                        this.props.building.doCustomize.detailsEventTitleColor.indexOf('#') > -1 ? (
                          this.props.building.doCustomize.detailsEventTitleColor
                        ) : (
                          '#' + this.props.building.doCustomize.detailsEventTitleColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    ),
                    fontStyle: this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsEventTitleStyle
                      : 'normal',
                    fontSize: this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsEventTitleSize + 'px'
                      : '14px',
                    textAlign: 'center'
                  }}>
                  Title Text
                </div>
                <br />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsEventTitleColor'
                  hintText='HexColor'
                  floatingLabelText4='HexColor'
                  maxlength='7'
                  value={
                    this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsEventTitleColor
                        ? this.props.building.doCustomize.detailsEventTitleColor.indexOf('#') > -1
                          ? this.props.building.doCustomize.detailsEventTitleColor
                          : '#' + this.props.building.doCustomize.detailsEventTitleColor
                        : null
                      : null
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />

                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsEventTitleStyle'
                  hintText='Style'
                  floatingLabelText2='Style'
                  value={
                    this.props.building.doCustomize ? this.props.building.doCustomize.detailsEventTitleStyle : 'normal'
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsEventTitleSize'
                  hintText='Size'
                  floatingLabelText1='Size'
                  value={
                    this.props.building.doCustomize ? this.props.building.doCustomize.detailsEventTitleSize : '14px'
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <br />
                <div
                  className='text'
                  style={{
                    color: this.props.building.doCustomize ? (
                      this.props.building.doCustomize.detailsEventDateColor ? (
                        this.props.building.doCustomize.detailsEventDateColor.indexOf('#') > -1 ? (
                          this.props.building.doCustomize.detailsEventDateColor
                        ) : (
                          '#' + this.props.building.doCustomize.detailsEventDateColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    ),
                    fontStyle: this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsEventDateStyle
                      : 'normal',
                    fontSize: this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsEventDateSize + 'px'
                      : '14px',
                    textAlign: 'center'
                  }}>
                  Date Text
                </div>
                <br />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsEventDateColor'
                  hintText='HexColor'
                  floatingLabelText4='HexColor'
                  maxlength='7'
                  value={
                    this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsEventDateColor
                        ? this.props.building.doCustomize.detailsEventDateColor.indexOf('#') > -1
                          ? this.props.building.doCustomize.detailsEventDateColor
                          : '#' + this.props.building.doCustomize.detailsEventDateColor
                        : null
                      : null
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsEventDateStyle'
                  hintText='Style'
                  floatingLabelText2='Style'
                  value={
                    this.props.building.doCustomize ? this.props.building.doCustomize.detailsEventDateStyle : 'normal'
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsEventDateSize'
                  hintText='Size'
                  floatingLabelText1='Size'
                  value={
                    this.props.building.doCustomize ? this.props.building.doCustomize.detailsEventDateSize : '14px'
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <div
                  className='text'
                  style={{
                    color: this.props.building.doCustomize ? (
                      this.props.building.doCustomize.detailsBuildingNameColor ? (
                        this.props.building.doCustomize.detailsBuildingNameColor.indexOf('#') > -1 ? (
                          this.props.building.doCustomize.detailsBuildingNameColor
                        ) : (
                          '#' + this.props.building.doCustomize.detailsBuildingNameColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    ),
                    fontStyle: this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsBuildingNameStyle
                      : 'normal',
                    fontSize: this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsBuildingNameSize + 'px'
                      : '14px',
                    textAlign: 'center'
                  }}>
                  Building Name Text
                </div>
                <br />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsBuildingNameColor'
                  hintText='HexColor'
                  floatingLabelText4='HexColor'
                  maxlength='7'
                  value={
                    this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsBuildingNameColor
                        ? this.props.building.doCustomize.detailsBuildingNameColor.indexOf('#') > -1
                          ? this.props.building.doCustomize.detailsBuildingNameColor
                          : '#' + this.props.building.doCustomize.detailsBuildingNameColor
                        : null
                      : null
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsBuildingNameStyle'
                  hintText='Style'
                  floatingLabelText2='Style'
                  value={
                    this.props.building.doCustomize
                      ? this.props.building.doCustomize.detailsBuildingNameStyle
                      : 'normal'
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsBuildingNameSize'
                  hintText='Size'
                  floatingLabelText1='Size'
                  value={
                    this.props.building.doCustomize ? this.props.building.doCustomize.detailsBuildingNameSize : '14px'
                  }
                  onChange={this.updateDoCustomizeField.bind(this)}
                />
                <br />
              </div>
            </Tab>

            {/* BOOK Customization */}
            <Tab label='BOOK'>
              <div style={leftPanelStyle}>
                <h3>List Book</h3>
                <TextField
                  style={{ width: '350px' }}
                  name='listBackgroundColor'
                  hintText='Background HexColor'
                  floatingLabelText='Background HexColor'
                  maxlength='7'
                  value={
                    this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.listBackgroundColor
                        ? this.props.building.bookCustomize.listBackgroundColor.indexOf('#') > -1
                          ? this.props.building.bookCustomize.listBackgroundColor
                          : '#' + this.props.building.bookCustomize.listBackgroundColor
                        : null
                      : null
                  }
                  onChange={this.updateBookCustomizeField.bind(this)}
                />
                <div
                  className='square'
                  style={{
                    backgroundColor: this.props.building.bookCustomize ? (
                      this.props.building.bookCustomize.listBackgroundColor ? (
                        this.props.building.bookCustomize.listBackgroundColor.indexOf('#') > -1 ? (
                          this.props.building.bookCustomize.listBackgroundColor
                        ) : (
                          '#' + this.props.building.bookCustomize.listBackgroundColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    )
                  }}
                />
                <br />
                <div
                  className='text'
                  style={{
                    color: this.props.building.bookCustomize ? (
                      this.props.building.bookCustomize.listLocationNameColor ? (
                        this.props.building.bookCustomize.listLocationNameColor.indexOf('#') > -1 ? (
                          this.props.building.bookCustomize.listLocationNameColor
                        ) : (
                          '#' + this.props.building.bookCustomize.listLocationNameColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    ),
                    fontStyle: this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.listLocationNameStyle
                      : 'normal',
                    fontSize: this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.listLocationNameSize + 'px'
                      : '14px',
                    textAlign: 'center'
                  }}>
                  Location Name text
                </div>
                <br />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='listLocationNameColor'
                  hintText='HexColor'
                  floatingLabelText3='HexColor'
                  maxlength='7'
                  value={
                    this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.listLocationNameColor
                        ? this.props.building.bookCustomize.listLocationNameColor.indexOf('#') > -1
                          ? this.props.building.bookCustomize.listLocationNameColor
                          : '#' + this.props.building.bookCustomize.listLocationNameColor
                        : null
                      : null
                  }
                  onChange={this.updateBookCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='listLocationNameStyle'
                  hintText='Style'
                  floatingLabelText2='Style'
                  value={
                    this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.listLocationNameStyle
                      : 'normal'
                  }
                  onChange={this.updateBookCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='listLocationNameSize'
                  hintText='Size'
                  floatingLabelText1='Size'
                  value={
                    this.props.building.bookCustomize ? this.props.building.bookCustomize.listLocationNameSize : '14px'
                  }
                  onChange={this.updateBookCustomizeField.bind(this)}
                />
                <br />
              </div>
              <div style={rightPanelStyle}>
                <h3>Details Book</h3>
                <TextField
                  style={{ width: '350px' }}
                  name='detailsBackgroundColor'
                  hintText='Background HexColor'
                  floatingLabelText='Background HexColor'
                  maxlength='7'
                  value={
                    this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.detailsBackgroundColor
                        ? this.props.building.bookCustomize.detailsBackgroundColor.indexOf('#') > -1
                          ? this.props.building.bookCustomize.detailsBackgroundColor
                          : '#' + this.props.building.bookCustomize.detailsBackgroundColor
                        : null
                      : null
                  }
                  onChange={this.updateBookCustomizeField.bind(this)}
                />
                <div
                  className='square'
                  style={{
                    backgroundColor: this.props.building.bookCustomize ? (
                      this.props.building.bookCustomize.detailsBackgroundColor ? (
                        this.props.building.bookCustomize.detailsBackgroundColor.indexOf('#') > -1 ? (
                          this.props.building.bookCustomize.detailsBackgroundColor
                        ) : (
                          '#' + this.props.building.bookCustomize.detailsBackgroundColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    )
                  }}
                />
                <br />
                <div
                  className='text'
                  style={{
                    color: this.props.building.bookCustomize ? (
                      this.props.building.bookCustomize.detailsLocationNameColor ? (
                        this.props.building.bookCustomize.detailsLocationNameColor.indexOf('#') > -1 ? (
                          this.props.building.bookCustomize.detailsLocationNameColor
                        ) : (
                          '#' + this.props.building.bookCustomize.detailsLocationNameColor
                        )
                      ) : (
                        <div />
                      )
                    ) : (
                      '#000000'
                    ),
                    fontStyle: this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.detailsLocationNameStyle
                      : 'normal',
                    fontSize: this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.detailsLocationNameSize + 'px'
                      : '14px',
                    textAlign: 'center'
                  }}>
                  Location Name Text
                </div>
                <br />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsLocationNameColor'
                  hintText='HexColor'
                  floatingLabelText3='HexColor'
                  maxlength='7'
                  value={
                    this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.detailsLocationNameColor
                        ? this.props.building.bookCustomize.detailsLocationNameColor.indexOf('#') > -1
                          ? this.props.building.bookCustomize.detailsLocationNameColor
                          : '#' + this.props.building.bookCustomize.detailsLocationNameColor
                        : null
                      : null
                  }
                  onChange={this.updateBookCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsLocationNameStyle'
                  hintText='Style'
                  floatingLabelText2='Style'
                  value={
                    this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.detailsLocationNameStyle
                      : 'normal'
                  }
                  onChange={this.updateBookCustomizeField.bind(this)}
                />
                <br />
                <TextField
                  style={{ width: '350px' }}
                  name='detailsLocationNameSize'
                  hintText='Size'
                  floatingLabelText1='Size'
                  value={
                    this.props.building.bookCustomize
                      ? this.props.building.bookCustomize.detailsLocationNameSize
                      : '14px'
                  }
                  onChange={this.updateBookCustomizeField.bind(this)}
                />
                <br />
              </div>
            </Tab>

            {/* ASSEMBLY Customization */}
            <Tab label='ASSEMBLE'>
              <TextField
                style={{ width: '350px' }}
                name='backgroundColor'
                hintText='Background HexColor'
                floatingLabelText='Background HexColor'
                maxlength='7'
                value={
                  this.props.building.assemblyCustomize
                    ? this.props.building.assemblyCustomize.backgroundColor
                      ? this.props.building.assemblyCustomize.backgroundColor.indexOf('#') > -1
                        ? this.props.building.assemblyCustomize.backgroundColor
                        : '#' + this.props.building.assemblyCustomize.backgroundColor
                      : null
                    : null
                }
                onChange={this.updateAssemblyCustomizeField.bind(this)}
              />
              <div
                className='square'
                style={{
                  backgroundColor: this.props.building.assemblyCustomize ? (
                    this.props.building.assemblyCustomize.backgroundColor ? (
                      this.props.building.assemblyCustomize.backgroundColor.indexOf('#') > -1 ? (
                        this.props.building.assemblyCustomize.backgroundColor
                      ) : (
                        '#' + this.props.building.assemblyCustomize.backgroundColor
                      )
                    ) : (
                      <div />
                    )
                  ) : (
                    '#000000'
                  )
                }}
              />
              <br />
              <div
                className='text'
                style={{
                  color: this.props.building.assemblyCustomize ? (
                    this.props.building.assemblyCustomize.fontColor ? (
                      this.props.building.assemblyCustomize.fontColor.indexOf('#') > -1 ? (
                        this.props.building.assemblyCustomize.fontColor
                      ) : (
                        '#' + this.props.building.assemblyCustomize.fontColor
                      )
                    ) : (
                      <div />
                    )
                  ) : (
                    '#000000'
                  ),
                  fontStyle: this.props.building.assemblyCustomize
                    ? this.props.building.assemblyCustomize.fontStyle
                    : 'normal',
                  fontSize: this.props.building.assemblyCustomize
                    ? this.props.building.assemblyCustomize.fontSize + 'px'
                    : '14px',
                  textAlign: 'center'
                }}>
                Assemble Text
              </div>
              <br />
              <br />
              <TextField
                style={{ width: '350px' }}
                name='fontColor'
                hintText='HexColor'
                floatingLabelText='HexColor'
                maxlength='7'
                value={
                  this.props.building.assemblyCustomize
                    ? this.props.building.assemblyCustomize.fontColor
                      ? this.props.building.assemblyCustomize.fontColor.indexOf('#') > -1
                        ? this.props.building.assemblyCustomize.fontColor
                        : '#' + this.props.building.assemblyCustomize.fontColor
                      : null
                    : null
                }
                onChange={this.updateAssemblyCustomizeField.bind(this)}
              />
              <br />
              <TextField
                style={{ width: '350px' }}
                name='fontStyle'
                hintText='Style'
                floatingLabelText2='Style'
                value={
                  this.props.building.assemblyCustomize ? this.props.building.assemblyCustomize.fontStyle : 'normal'
                }
                onChange={this.updateAssemblyCustomizeField.bind(this)}
              />
              <br />
              <TextField
                style={{ width: '350px' }}
                name='fontSize'
                hintText='Size'
                floatingLabelText1='Size'
                value={this.props.building.assemblyCustomize ? this.props.building.assemblyCustomize.fontSize : '14px'}
                onChange={this.updateAssemblyCustomizeField.bind(this)}
              />
              <br />
            </Tab>

            {/* FILTER Customization */}
            <Tab label='FILTER'>
              <TextField
                style={{ width: '350px' }}
                name='backgroundColor'
                hintText='Background HexColor'
                floatingLabelText='Background HexColor'
                maxlength='7'
                value={
                  this.props.building.filterCustomize
                    ? this.props.building.filterCustomize.backgroundColor
                      ? this.props.building.filterCustomize.backgroundColor.indexOf('#') > -1
                        ? this.props.building.filterCustomize.backgroundColor
                        : '#' + this.props.building.filterCustomize.backgroundColor
                      : null
                    : null
                }
                onChange={this.updateFilterCustomizeField.bind(this)}
              />
              <div
                className='square'
                style={{
                  backgroundColor: this.props.building.filterCustomize ? (
                    this.props.building.filterCustomize.backgroundColor ? (
                      this.props.building.filterCustomize.backgroundColor.indexOf('#') > -1 ? (
                        this.props.building.filterCustomize.backgroundColor
                      ) : (
                        '#' + this.props.building.filterCustomize.backgroundColor
                      )
                    ) : (
                      <div />
                    )
                  ) : (
                    '#000000'
                  )
                }}
              />

              <br />
              <div
                className='text'
                style={{
                  color: this.props.building.filterCustomize ? (
                    this.props.building.filterCustomize.fontColor ? (
                      this.props.building.filterCustomize.fontColor.indexOf('#') > -1 ? (
                        this.props.building.filterCustomize.fontColor
                      ) : (
                        '#' + this.props.building.filterCustomize.fontColor
                      )
                    ) : (
                      <div />
                    )
                  ) : (
                    '#000000'
                  ),
                  fontStyle: this.props.building.filterCustomize
                    ? this.props.building.filterCustomize.fontStyle
                    : 'normal',
                  fontSize: this.props.building.filterCustomize
                    ? this.props.building.filterCustomize.fontSize + 'px'
                    : '14px',
                  textAlign: 'center'
                }}>
                Filter Title Text
              </div>
              <br />
              <br />
              <TextField
                style={{ width: '350px' }}
                name='fontColor'
                hintText='HexColor'
                floatingLabelText='HexColor'
                maxlength='7'
                value={
                  this.props.building.filterCustomize
                    ? this.props.building.filterCustomize.fontColor
                      ? this.props.building.filterCustomize.fontColor.indexOf('#') > -1
                        ? this.props.building.filterCustomize.fontColor
                        : '#' + this.props.building.filterCustomize.fontColor
                      : null
                    : null
                }
                onChange={this.updateFilterCustomizeField.bind(this)}
              />
              <br />
              <TextField
                style={{ width: '350px' }}
                name='fontStyle'
                hintText='Style'
                floatingLabelText2='Style'
                value={this.props.building.filterCustomize ? this.props.building.filterCustomize.fontStyle : 'normal'}
                onChange={this.updateFilterCustomizeField.bind(this)}
              />
              <br />
              <TextField
                style={{ width: '350px' }}
                name='fontSize'
                hintText='Size'
                floatingLabelText1='Size'
                value={this.props.building.filterCustomize ? this.props.building.filterCustomize.fontSize : '14px'}
                onChange={this.updateFilterCustomizeField.bind(this)}
              />
              <br />
            </Tab>
          </Tabs>
        </Dialog>
      )
    } else {
      return <div />
    }
  }
}
const mapStateToProps = state => {
  return state.buildingsReducer
}

export default connect(mapStateToProps)(CustomizeBuildings)


// WEBPACK FOOTER //
// ./src/components/buildings/CustomizeBuildings.js